import { render, staticRenderFns } from "./DetailFacture.vue?vue&type=template&id=dc160390"
import script from "./DetailFacture.vue?vue&type=script&lang=js"
export * from "./DetailFacture.vue?vue&type=script&lang=js"
import style0 from "./DetailFacture.vue?vue&type=style&index=0&id=dc160390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports